// import React from 'react';
// import './Footer.css';

// function Footer() {
//   return (
//     <footer className="footer">
//       <div className="footer-container">
//         {/* Left Side: Contact Info */}
//         <div className="footer-contact">
//           <h2>ProMaster Consulting</h2>
//           <p>Email: <a href="promaster.consulting@gmail.com">promaster.consulting@gmail.com</a></p>
//           <p>Mobile: <a href="tel:+1234567890">+1 234 567 890</a></p>
//           <p>Address: 123 Main St, City, Country</p>
//         </div>

//         {/* Right Side: Page Links */}
//         <div className="footer-links">
//           <a href="/">Home</a>
//           <a href="/about">About</a>
//           <a href="/services">Services</a>
//           <a href="/contact">Contact</a>
//         </div>
//       </div>

//       <p className="footer-bottom">
//         &copy; {new Date().getFullYear()} ProMaster. All rights reserved.
//       </p>
//     </footer>
//   );
// }

// export default Footer;

import React from 'react';
import './Footer.css';

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-main">
        {/* Left: Brand */}
        <div className="footer-row footer-brand">
          <h3>ProMaster Consulting</h3>
          <p>ProMaster Consulting is a solutions-driven firm specializing in data mining, security consulting, and digital marketing. We help businesses unlock insights, safeguard operations, and grow their digital presence with confidence.</p>
        </div>

        {/* Center: Page Links */}
        <div className="footer-row footer-links">
          <h3>links</h3>
          <a href="/">Home</a>
          <a href="/about">About</a>
          <a href="/services">Services</a>
          <a href="/contact">Contact</a>
        </div>

        {/* Right: Contact Info */}
        <div className="footer-row footer-contact">
          <h3>ContactUs</h3>
          <p>Email: <a href="mailto:promaster.consulting@gmail.com">promaster.consulting@gmail.com</a></p>
          <p>Mobile: <a href="tel:+1234567890">+91 70210520017</a></p>
          <p>Address: A-117, Sector 72, Gautam Buddha Nagar, Noida, Uttar Pradesh-201301</p>
        </div>
      </div>

      <p className="footer-bottom">
        &copy; {new Date().getFullYear()} ProMaster. All rights reserved.
      </p>
    </footer>
  );
}

export default Footer;